export enum EnvironmentNameEnum {
    DEV = 'dev',
    PROD = 'prod',
    STAGING = 'staging',
    TEST = 'test',
}

export interface Environment {
    baseApiUrl: string;
    env: EnvironmentNameEnum;
    production: boolean;
    sentryUrl?: string;
}
